<template>
  <div>
    <h3>About</h3>
    <div class="text-sm text-gray-500 mb-4"></div>
    <div class="max-w-screen-sm">
      <p>
        Staff AI Engineer at Pareto AI, building distributed systems that produce synthetic data, RL tasks and realistic environments for frontier AI labs.
        Previously co-founded <a class="font-bold" target="_blank" href="https://cyclic.sh">cyclic.sh</a>, a serverless PaaS scaled to 150k+ signups.
      </p>
      <p>
        I build with TypeScript, Python, Temporal, AWS, Terraform, and more. Without AI, I also build physical things with wood, metal, and concrete.
      </p>
      </div>
    </div>
</template>

<script>
export default {
  name: 'About',
  props: {
    msg: String
  },
  data(){
    return{
    }
  },
  async mounted() {   
    },
  methods:{
    
  }
}
</script>

